module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 5a9 9 0 017.032 14.617l5.1 5.1a.5.5 0 010 .708l-.707.707a.5.5 0 01-.707 0l-5.1-5.1A9 9 0 1114 5zm0 2a7 7 0 100 14 7 7 0 000-14zm.5 3a.5.5 0 01.5.5v2.499l2.5.001a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H15v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V15h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H13v-2.5a.5.5 0 01.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/basic/asda-zoom.svg
// module id = 628
// module chunks = 0